import React, { useCallback, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { useHistory, useLocation } from 'react-router-dom';
import { CloseCircleIcon } from '../../apps/Cards/icons/CloseCircle';
import { Card } from '../Card';
import { usePopup } from '../../hooks/usePopup';
import './PopupCardSeries.scss';
import Dropdown from 'rc-dropdown';
import 'rc-dropdown/assets/index.css';
import Menu, { Item as MenuItem } from 'rc-menu';
import { usePrevious } from '../../hooks/usePrevious';

export const PopupCardSeries = ({
  searchParam = false,
  closeModal,
  seriesSeason = 1,
  card: {
    cover,
    cover_wide,
    post_name,
    cover_lowres,
    title,
    description,
    meta_type,
    meta_level,
    series,
  },
}) => {
  const history = useHistory();
  const location = useLocation();
  const [activeSeason, setActiveSeason] = useState(seriesSeason);
  const [seasons, setSeasons] = useState(null);
  const prevSeason = usePrevious(activeSeason)

  function handleClose(e) {
    if(searchParam) {
      const searchParams = (new URL(document.location)).searchParams;

      if (searchParams.has('season')) searchParams.delete('season');
      if (searchParams.has('series')) searchParams.delete('series');  
      
      history.push({
        pathname: location.pathname,
        search: searchParams.toString()
      });
    }

    // actid=8.1
    window.analytics?.track("button:click", {
      "button_name": "Close",
      "title": title,
    });

    closeModal();
    e?.stopPropagation();
  }

  usePopup(handleClose);

  const handleSeasonRouteChange = useCallback(() =>  {
    if (!seasons || activeSeason === prevSeason) return

    const searchParams = (new URL(document.location)).searchParams;

    if (searchParams.has('season')) {
      searchParams.delete('season')
    } 
    searchParams.append('season', `${activeSeason}`)
    
    history.push({
      pathname: location.pathname,
      search: searchParams.toString(),
    });
  }, [activeSeason, history, location, seasons, prevSeason])

  useEffect(() => {
    const searchParams = (new URL(document.location)).searchParams;

    if(searchParam && post_name && !searchParams.has('series')) {
      history.push({
        pathname: location.pathname,
        search: `${location.search}${location.search ? '&' : '?'}series=${post_name}&season=${activeSeason}`
      });
    }
    handleSeasonRouteChange()
  }, [searchParam, history, location, post_name,  activeSeason, handleSeasonRouteChange]);

  

  useEffect(() => {
    const seasons = series.reduce((acc, curr) => {
      const seasonNumber = curr.season || 1;
      const currentSeason = acc[seasonNumber] || [];
      return {
        ...acc,
        [seasonNumber]: [...currentSeason, curr],
      };
    }, {});
    setSeasons(seasons);
  }, [series]);

  function handleCardSerieClick(card) {
    // actid=8.2
    window.analytics?.track("object:click", {
      "object_name": card.title,
      "parent_object_title": title,
      "title": card.title,
      "url": card.url
    });

    if(!card.post_name) {
      return;
    }

    handleClose();
  }

  const getCover = () => {
    if  (cover_wide) return cover_wide;
    if (cover) return cover;
    return cover_lowres?.[0];
  };

  const DropDown = ({ seasons }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    if (!seasons) return null;

    const seasonsCount = Object.keys(seasons).length;
    if (seasonsCount < 2) return null;

    const onSelect = ({ key }) => {
      setActiveSeason(key);
      document.getElementById("series-modal").classList.remove("no-scroll");
    };

    const menu = (
      <Menu onSelect={onSelect}>
        {Object.entries(seasons).map(([season, episodes]) => {
          return (
            <MenuItem key={season}>
              Season {season} <span className="rc-dropdown-menu-item-episods">({episodes.length} Episodes)</span>
            </MenuItem>
          );
        })}
      </Menu>
    );

    const onVisibleChange = (visible) => {
      if (visible) {
        document.getElementById("series-modal").classList.add("no-scroll");
        setIsExpanded(true);
      } else {
        document.getElementById("series-modal").classList.remove("no-scroll");
        setIsExpanded(false);
      }
    };

    return (
      <div>
        <Dropdown
          trigger={["click"]}
          overlay={menu}
          animation="slide-up"
          getPopupContainer={() => document.getElementById("pc-popup-portal")}
          onVisibleChange={onVisibleChange}
        >
          <button className="PopupCardSeries__dropdown-button">
            Season {activeSeason}
            <div
              style={{
                transform: `rotate(${isExpanded ? 0 : 180}deg)`,
                marginBottom: isExpanded ? '2px' : '-4px',
              }}
              className="PopupCardSeries__dropdown-button-triangle"
            ></div>
          </button>
        </Dropdown>
      </div>
    );
  };

  return ReactDOM.createPortal(
    <div id="series-modal" className="PopupCardSeries">
      <div className="PopupCardSeries__backdrop" onClick={handleClose} />

      <div className="PopupCardSeries__window">
        <div className="PopupCardSeries__image-block">
          <img src={getCover()} alt="" className="PopupCardSeries__image" />
          <button className="PopupCardSeries__close" onClick={handleClose}>
            <CloseCircleIcon />
          </button>
        </div>

        <div className="PopupCardSeries__content">
          <h3 className="PopupCardSeries__title">{title}</h3>

          <div className="PopupCardSeries__row">
            {description && (
              <div className="PopupCardSeries__description" dangerouslySetInnerHTML={{ __html: description }} />
            )}

            <ul className="PopupCardSeries__meta">
              <li className="PopupCardSeries__meta-item">
                <b>Type: </b>{meta_type.join(', ')}
              </li>
              <li className="PopupCardSeries__meta-item">
                <b>Level: </b>{meta_level.join(', ')}
              </li>
            </ul>
          </div>

          <div className="PopupCardSeries__seasons">
            <h3 className="PopupCardSeries__title">Episodes</h3>
            <DropDown
              className="PopupCardSeries__seasons-box"
              seasons={seasons}
            />
          </div>
          <div className="PopupCardSeries__series PopupCardSeries__series_list">
            {seasons &&
              seasons[activeSeason].map((card, i) => (
                <div className="PopupCardSeries__series-item" key={card.id}>
                  <Card
                    isSeria
                    type="classes"
                    seriaNumber={i + 1}
                    cardItem={card}
                    onClick={handleCardSerieClick}
                  />
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>,
    document.getElementById('pc-popup-portal'));
};
